import { render, staticRenderFns } from "./repay-list.vue?vue&type=template&id=3b54c353"
import script from "./repay-list.vue?vue&type=script&lang=ts"
export * from "./repay-list.vue?vue&type=script&lang=ts"
import style0 from "./repay-list.vue?vue&type=style&index=0&id=3b54c353&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports